export default "__VITE_PUBLIC_ASSET__695dab23__"